module.exports = __webpack_public_path__ + "static/banner-93b8257276a47e99a3de80d096f8b941.png";